const termlyListeners = () => {
  /**
   * Add a click listener for a class, href/anchor, and data attirbute to open the Termly Cookie Preferences panel/modal. Fall back to a URL defined in Theme Settings if Termly function isn't available.
   */
  const termlyButtons = document.querySelectorAll( '.js-termly-open-preferences,.termly-cookie-preference-button,[href="#open_termly_preferences"],[data-trigger-termly-preferences]' );
  if ( termlyButtons.length ) {
    termlyButtons.forEach( termlyButton => {
      termlyButton.addEventListener( 'click', e => {
        e.preventDefault();
        // Check for termly.io function
        if ( typeof window.displayPreferenceModal != 'undefined' || typeof window.displayPreferenceModal == 'function' ) {
          window.displayPreferenceModal();
        } else {
          console.error( 'Termly script not installed - instead navigate to cookie policy page (`'+window.termly_inactive_cookie_url+'`)' );
          window.location = window.termly_inactive_cookie_url;
        }
        return false;
      } );
    } );
  }
}
export { termlyListeners };
